import { Trans } from '@lingui/react'
import { Flex } from '@twistopayments/design-system/components/atoms/flex'
import { FormattedCurrencyNumber } from '@twistopayments/design-system/components/atoms/format'
import { Hidden } from '@twistopayments/design-system/components/atoms/hidden'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { useRouter } from 'next/router'
import { isNil } from 'ramda'

import { installmentsConfig } from '@twisto/base/installments-config'
import { useGetFlowData } from '@twisto/flow-views'

import { LearnMore } from './learn-more'
import * as styles from './pay-in-n-layout.styles'

export const OrderInfo = () => {
  const { query } = useRouter()
  const { flow } = useGetFlowData(query.sessionId as string)

  const step = flow?.currentStep
  const purchaseStepContext =
    step && 'purchaseContext' in step ? step.purchaseContext : null
  const onboardingPurchaseContext = flow?.context?.purchase
  const currentContext = purchaseStepContext ?? onboardingPurchaseContext

  if (isNil(currentContext)) {
    return null
  }

  const {
    orderAmount,
    maxInstallments,
    merchantName,
    installmentSelected,
    singleInstallment,
  } = currentContext

  const explanationMaxInstallments =
    maxInstallments ?? installmentsConfig.maximum_installments_months

  const amountWithInstallments =
    !isNil(installmentSelected) && !isNil(singleInstallment) ? (
      <>
        {`${installmentSelected} x `}
        <FormattedCurrencyNumber value={singleInstallment} />
      </>
    ) : null

  return (
    <div css={styles.root}>
      <Typography
        align="center"
        css={styles.siteIdentifierText}
        fontWeight="medium"
      >
        {merchantName}
      </Typography>
      <Typography
        align="center"
        css={styles.priceText}
        fontWeight="heavy"
        variant="h2"
      >
        {amountWithInstallments || (
          <FormattedCurrencyNumber value={orderAmount ?? ''} />
        )}
      </Typography>

      <Typography
        align="center"
        color="textSecondary"
        css={styles.noticeText}
        variant="b1"
      >
        <Flex alignItems="center" justify="center" wrap="noWrap">
          {!isNil(maxInstallments) && (
            <Trans
              id="flow.orderInfo.payInN.notice"
              values={{ maxMonths: maxInstallments }}
            />
          )}

          <Hidden smMdUp>
            <LearnMore maxInstallments={explanationMaxInstallments} />
          </Hidden>
        </Flex>
      </Typography>

      <Hidden smDown>
        <LearnMore maxInstallments={explanationMaxInstallments} />
      </Hidden>
    </div>
  )
}
